export const initSchedule = (sch, type) => {
  return {
    id: sch.id,
    type: type,
    scheduleNo: sch.scheduleNo,
    taxAdjustment: sch.taxAdjustment,
    name: sch.scheduleTitle,
    notes: sch.notes,
    reviewNotes: sch.reviewNotes
  };
};

export const initCompany = (states) => {
  if (!states || !states.company || !states.details) {
    return {
      c_id: null,
      name: "",
      uen: "",
      yearOfAssessment: "",
      financialYearStart: "",
      financialYearEnd: "",
      currency: "",
      currencyRate: "",
      manual_currency_rate: "",
      masAvailable: false,
      tc_id: null,
      companyType: "",
      taxPeriodType: "single_ya",
      basisPeriods: [],
      isCustomizedBasisPeriod: false
    };
  }

  return {
    c_id: states.company.c_id,
    name: states.company.name,
    uen: states.company.uen,
    yearOfAssessment: states.details.yearOfAssessment,
    financialYearStart: states.details.financialYearStart,
    financialYearEnd: states.details.financialYearEnd,
    currency: states.details.currency,
    currencyRate: states.details.currency_rate,
    manual_currency_rate:
      states.details?.manual_currency_rate || states.details.currency_rate,
    masAvailable: !(states.details?.masExchangeRate?.error === true),
    tc_id: states.details.tc_id,
    companyType: states.details.taxComputationType,
    taxPeriodType: states.details.taxPeriodType || "single_ya",
    basisPeriods: states.details.basisPeriods || [],
    isCustomizedBasisPeriod: Boolean(
      states.details.isCustomizedBasisPeriod
    )
  };
};
